import { createApiRequest } from "@/lib/api/createApiService";
import fetchApi from "@/lib/api/fetchApi";
import { ONBOARDING_ENDPOINTS } from "./onboarding.endpoints";

export const onboardingService = {
  fetchOnboard: async (companyId, options = {}) => {
    if (!companyId) throw new Error("companyId is required");
    return createApiRequest({
      url: ONBOARDING_ENDPOINTS.DETAIL(companyId),
      method: "GET",
      ...options,
    });
  },

  saveOnboard: async (project, companyId, payload, options = {}) => {
    if (!companyId || !project)
      throw new Error("companyId and project are required");
    return createApiRequest({
      url: ONBOARDING_ENDPOINTS.SAVE(project, companyId),
      method: "POST",
      body: payload,
      ...options,
    });
  },

  uploadFilesBatch: async (companyId, formData, options = {}) => {
    if (!companyId || !formData)
      throw new Error("companyId and formData are required");
    return createApiRequest({
      url: ONBOARDING_ENDPOINTS.UPLOAD_BATCH(companyId),
      method: "POST",
      body: formData,
      isFormData: true,
      ...options,
    });
  },

  sendMeetingRequest: async (payload, options = {}) => {
    return createApiRequest({
      url: ONBOARDING_ENDPOINTS.MEETING_REQUEST,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  sendNotification: async (payload, options = {}) => {
    return createApiRequest({
      url: ONBOARDING_ENDPOINTS.SEND_NOTIFICATION,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  getNxmapCode: async (options = {}) => {
    const response = await fetchApi.post(ONBOARDING_ENDPOINTS.NXMAP_CODE, {});
    if (response?.success === true) {
      return response?.data ?? "";
    }
    const message =
      response?.message ||
      response?.error ||
      "Unable to retrieve NXMap access code.";
    if (options?.throwOnError === false) return null;
    throw new Error(message);
  },
};
